import { useState } from "react";
import { Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "../../ui/input";
import { api, formatApiError } from "../../../lib/api";
import { NETWORKS } from "../../../lib/share";

const PLACEHOLDER = { whatsapp: "Tu número con lada, ej. 5213312345678", facebook: "Usuario o enlace de tu perfil", instagram: "@usuario", tiktok: "@usuario", youtube: "@canal o enlace" };

/** Paso 1 · cuentas personales del distribuidor. */
export const SocialsForm = ({ socials, onSaved }) => {
  const [form, setForm] = useState(socials);
  const [busy, setBusy] = useState(false);
  const connected = Object.values(form).filter(Boolean).length;
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.patch("/me/marketing/socials", form);
      onSaved(data);
      toast.success("Cuentas guardadas: tu plan semanal usará estas redes");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={save} className="rounded-[1.5rem] border border-ink/10 bg-white p-5" data-testid="socials-form">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-sm text-ink/70">Captura tus cuentas personales. Con ellas armamos tu calendario y abrimos cada red con un toque.</p>
        <span className="rounded-full bg-leaf/15 px-3 py-1 text-xs font-semibold text-leaf-deep" data-testid="socials-connected">{connected} de 5 conectadas</span>
      </div>
      <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-5">
        {NETWORKS.map(({ id, label, Icon, color }) => (
          <label key={id} className="block">
            <span className="mb-1 flex items-center gap-1.5 text-xs font-semibold"><Icon className="h-3.5 w-3.5" style={{ color }} /> {label} {form[id] && <Check className="h-3 w-3 text-leaf-deep" />}</span>
            <Input value={form[id] || ""} onChange={(e) => setForm({ ...form, [id]: e.target.value })} placeholder={PLACEHOLDER[id]} className="h-10 bg-paper" data-testid={`social-${id}`} />
          </label>
        ))}
      </div>
      <button type="submit" disabled={busy} className="btn-ink mt-4 !px-5 !py-2.5 !text-xs disabled:opacity-60" data-testid="socials-save">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Check className="h-4 w-4" />} Guardar mis cuentas</button>
    </form>
  );
};
